import {error_color} from "./colors";

export const orangeButtonStyle = { color: 'white' }
export const grayButtonStyle = { color: 'gray' }
export const errorButtonStyle = { color: 'white', backgroundColor: error_color }

